import { getEnumLabel } from "./commissionEnums";

export const PARTNER_FRAUD_ALERT_TYPE_LABELS = {
  MultipleRegistrationsSameIp: "ثبت‌نام‌های متعدد از یک IP",
  SuspiciousVisitorPattern: "الگوی مشکوک بازدیدکننده / دستگاه",
  RepeatedAttributionAttempts: "تلاش‌های مکرر نسبت‌دهی",
  RepeatedPayoutFailure: "شکست‌های مکرر تسویه",
};

export const PARTNER_FRAUD_ALERT_STATUS_LABELS = {
  Open: "باز",
  Reviewed: "بررسی‌شده",
  Dismissed: "رد شده",
};

export const FRAUD_ALERT_SEVERITY_LABELS = {
  High: "بالا",
  Medium: "متوسط",
  Low: "پایین",
};

const ALERT_TYPE_SEVERITY = {
  MultipleRegistrationsSameIp: "High",
  SuspiciousVisitorPattern: "Medium",
  RepeatedAttributionAttempts: "Medium",
  RepeatedPayoutFailure: "High",
};

export const getFraudAlertTypeLabel = (alertType) =>
  getEnumLabel(PARTNER_FRAUD_ALERT_TYPE_LABELS, alertType);

export const getFraudAlertStatusLabel = (status) =>
  getEnumLabel(PARTNER_FRAUD_ALERT_STATUS_LABELS, status);

export const getFraudAlertSeverity = (alertType) =>
  ALERT_TYPE_SEVERITY[String(alertType || "")] || "Medium";

export const getFraudAlertSeverityLabel = (alertType) =>
  getEnumLabel(FRAUD_ALERT_SEVERITY_LABELS, getFraudAlertSeverity(alertType));

export const getFraudAlertTypesBySeverity = (severity) => {
  if (!severity) return null;
  return Object.entries(ALERT_TYPE_SEVERITY)
    .filter(([, value]) => value === severity)
    .map(([key]) => key);
};

export const getFraudAlertStatusChipColor = (status) => {
  const s = String(status || "");
  if (s === "Open") return "error";
  if (s === "Reviewed") return "success";
  if (s === "Dismissed") return "default";
  return "default";
};

export const getFraudAlertSeverityChipColor = (alertType) => {
  const severity = getFraudAlertSeverity(alertType);
  if (severity === "High") return "error";
  if (severity === "Medium") return "warning";
  return "info";
};
